import React, { useEffect, useContext } from 'react';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { getAccessToken } from '../../../services/authentication';
import { useCurrentPortal } from '../../../hooks';
import { privilegesContext } from '../../../contexts/auth';


export const PrivateRoute = ({ id, path, component: Comp, redirectPath, pageTitle }) => {
  const token = getAccessToken();
  const currentPortal = useCurrentPortal();
  const privileges = useContext(privilegesContext);

  useEffect(() => {
    if (!token && window.location.pathname.indexOf('login') === -1) {
      window.location.replace(redirectPath ?? `/${currentPortal}/login?next=${window.location.pathname}`);
    }
  }, [ token ]);
  const ids = typeof (id) == 'number' ? [ id ] : id;

  return (
    ((privileges && privileges.some(i => ids.includes(i))) || id === 'public') && (
      //    true && (
      <Route
        exact
        path={ path }
        render={ () => (
          <section style={{ height: '100%' }}>
            <Helmet><title>{pageTitle}</title></Helmet>
            <Comp />
          </section>
        ) }
      />
    )
  );

};
